import { API_V2 } from 'constant/apiUrl'
import type { Fetch } from 'lib/fetch/type'
import type { ICommentV2 } from 'type/comment'
import type { IRespV2 } from 'type/common'
import type { ISpotV2 } from 'type/spot'

// V2
export const getSpotV2 = async (
  fetcher: Fetch,
  spotId: string,
  lang: string = 'en'
): Promise<IRespV2<ISpotV2>> => {
  const res = await fetcher(
    API_V2.CONTENT + `/spot/${spotId}` + `?lang=${lang}`
  )

  return res
}

export const getSpotsV2 = async (
  fetcher: Fetch,
  spotIds: string,
  lang: string = 'en'
): Promise<IRespV2<ISpotV2[]>> => {
  const res = await fetcher(
    API_V2.CONTENT + `/spots?ids=${spotIds}&lang=${lang}`
  )

  return res
}

/**
 * @param query ex: lang=en&size=10&page_token=xxx
 */
export const getSpotCommentsV2 = async (
  fetcher: Fetch,
  id: string,
  query?: string
): Promise<
  IRespV2<{ comments: ICommentV2[]; next_page_token?: string | null }>
> => {
  const res = await fetcher(
    API_V2.CONTENT + `/spot/${id}/comments${query ? `?${query}` : ''}`
  )

  return res
}
